module.exports = __webpack_public_path__ + "static/media/logo_en.41e62dc9.svg";